import { DeserializedFarm } from 'state/types'

const isBoostFarm = (farm: DeserializedFarm): boolean => {
  return (farm.enableBoost && !farm.boostFarmExpired) || Boolean(farm.ecoFarm)
}

export default isBoostFarm
